import { ReactElement, useEffect } from "react";
import { navigateTo } from "client_legacy/ndaw/navigator";
import { HubDataSource } from "client/Api/Hub/hub";
import { getHubUrlForCommunity } from "client/Features/Hub/Communities/CommunitiesPage";

export type CommunityMembershipRequestDeclinedActivityInvocationProps = {
	onDismiss: () => void;
};

export const CommunityMembershipRequestDeclinedActivityInvocation = (
	props: CommunityMembershipRequestDeclinedActivityInvocationProps
): ReactElement | null => {
	const { onDismiss } = props;

	useEffect(
		() => {
			const url: string = getHubUrlForCommunity({
				source: HubDataSource.Community
			});

			navigateTo(url);
			onDismiss();
		},
		[onDismiss]
	);

	return null;
};

CommunityMembershipRequestDeclinedActivityInvocation.displayName = "CommunityMembershipRequestDeclinedActivityInvocation";
